var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStep5(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A82939;}\n\t.st1{fill:none;stroke:#75232E;stroke-width:5;}\n\t.st2{fill:#A21B2C;}\n\t.st3{fill:none;stroke:#75232E;stroke-width:4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.8,58.7c6.4,0,12.4-4.6,12.4-12.8c0-8.1-5-11.7-11.2-11.7c-2,0-3.4,0.5-5,1.3l0.9-9.4h13.6v-4.9H31.8 l-1.1,17.5l2.8,1.8c2.2-1.4,3.6-2.1,5.9-2.1c4.2,0,7,2.8,7,7.7s-3.2,7.8-7.3,7.8c-3.9,0-6.5-1.8-8.6-3.9l-2.8,3.8 C30.4,56.3,34,58.7,39.8,58.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 40,
    cy: 40,
    r: 37.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep5);
export default __webpack_public_path__ + "static/media/step5.e3d93a07.svg";
export { ForwardRef as ReactComponent };